// Initialize Google Analytics with your Measurement ID
// Using native gtag.js implementation directly from the HTML file
export const initGA = () => {
  // The initialization is already done in the HTML head with gtag.js
  // This function is kept for compatibility with existing code
};

// Track page views
export const trackPageView = (path) => {
  if (window.gtag) {
    window.gtag('config', 'G-14BZPV3VF0', {
      page_path: path
    });
  }
};

// Track custom events
export const trackEvent = (category, action, label = null, value = null) => {
  if (window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value
    });
  }
};

// Track user interactions
export const trackUserInteraction = (action, description = null) => {
  trackEvent('User Interaction', action, description);
};

// Track specific business card actions
export const trackCardAction = (action, cardId = null) => {
  trackEvent('Business Card', action, cardId);
};

// Enhanced e-commerce tracking (if needed)
export const trackTransaction = (transactionId, total, items) => {
  if (window.gtag) {
    window.gtag('event', 'purchase', {
      transaction_id: transactionId,
      value: total,
      currency: 'USD',
      items: items
    });
  }
};

// Track user timing for performance monitoring
export const trackTiming = (category, variable, time) => {
  if (window.gtag) {
    window.gtag('event', 'timing_complete', {
      name: variable,
      event_category: category,
      value: time
    });
  }
};

// Track exceptions/errors
export const trackException = (description, fatal = false) => {
  if (window.gtag) {
    window.gtag('event', 'exception', {
      description: description,
      fatal: fatal
    });
  }
}; 